export default __webpack_public_path__ + "static/media/icon_triangle_down.b48dbb1a.svg";